import { routes } from '../RouterPath';
import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';

export const categoryBreadcrumbs = (categoryName = '') : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Каталог',
        url: '',
    },
    {
        key: '2',
        value: 'Категории',
        url: routes.settings,
    },
    {
        key: '3',
        value: categoryName,
        url: '',
    },
]);
